<div class="text-white">
  <div aria-label="open" matTooltip="View hours" class="text-base bg-[#4e6ea691] text-center leading-8 border-b border-gray-200 cursor-pointer rounded-b-lg justify-center 
    items-center gap-3 transition-all h-0 mobile:rounded-none" matRipple [matRippleCentered]="true"
    [matRippleColor]="'rgba(255, 255, 255, 0.1)'" [class.!rounded-none]="isExpanded" [class.h-8]="startAnimation"
    (click)="toggle()">
    <div class="flex items-center justify-center gap-3 hover:scale-[1.03] transition-all">
      <div class="w-3 h-3 rounded-full text-white ig-drop" [class.bg-red-400]="!openingHours.open_now"
        [class.bg-green-400]="openingHours.open_now">
      </div>
      {{openingHours.open_now ? 'OPEN NOW' : 'CLOSED NOW'}}
      <mat-icon class="leading-5">{{isExpanded ? 'expand_more' : 'chevron_left'}} </mat-icon>
    </div>
  </div>

  <div class="relative overflow-hidden text-sm rounded-b-lg" [class.h-0]="!isExpanded">
    <div class="transition-all relative -top-[280px] bg-[#4e6ea691] mobile:bg-[#4e6ea6d6]"
      [class.ig-opening-hours-show]="isExpanded">
      <div *ngFor="let t of openingHours.weekday_text"
        class="py-2 px-3 border-b border-solid text-white font-semibold border-gray-200 last:border-none">
        {{t}}
      </div>
    </div>
  </div>
</div>